// extracted by mini-css-extract-plugin
export default {"wrapper":"CookiePrivacy_wrapper__gght2","message":"CookiePrivacy_message__orMUM","button":"CookiePrivacy_button__S82ot"};